import React from 'react';
import {useTranslation} from "react-i18next";

import stub from '../../img/stub.png'
import {observer} from "mobx-react-lite";

const GameBoxComingSoon = () => {
    const {t} = useTranslation();

    return (
        <div className="box coming_soon">
            <div className="box_img">
                <img src={stub} alt="Coming Soon" />
            </div>
            <div className="box_description">
                <div className="box_title">
                    <h1>{t('New Game Coming Soon')}</h1>
                    <div className="key">
                        <span>ID</span>
                        <span className="number" />
                    </div>
                </div>
                <div className="box_inf">
                    <table>
                        <tbody>
                        <tr className="type">
                            <td>{t('Type')}:</td>
                            <td className="inf">X</td>
                        </tr>
                        <tr className="reels">
                            <td>{t('Reels')}:</td>
                            <td className="inf">X</td>
                        </tr>
                        <tr className="free">
                            <td>{t('Free games')}:</td>
                            <td className="inf">X</td>
                        </tr>
                        <tr className="bonus">
                            <td>{t('Bonus game')}:</td>
                            <td className="inf">X</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="box_button">
                    <div>{t('PLAY DEMO')}</div>
                    <div>{t('READ MORE')}</div>
                </div>
            </div>
        </div>
    );
};

export default observer(GameBoxComingSoon);